import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { clearUserInfo } from "@/store/modules/user";

export default function IdleTimer() {
  const dispatch = useDispatch();
  // 1. Use Ref records to avoid being reset by React during re-rendering.
  const lastActivity = useRef(Date.now());
  const timerInstance = useRef(null);

  useEffect(() => {
    // console.log("🛠️ [Debug] IdleTimer 初始化成功");

    const update = () => {
      lastActivity.current = Date.now();
      // The printout here shows whether the user has made any changes.
      // console.log("🖱️ User activities..."); 
    };

    // 2. Binding events
    window.addEventListener("mousedown", update);
    window.addEventListener("keydown", update);
    window.addEventListener("scroll", update);
    window.addEventListener("touchstart", update);

    // 3. Core inspection logic
    timerInstance.current = setInterval(() => {

      if (window.location.pathname.includes('/login')) return;
      
      const now = Date.now();
      const diff = now - lastActivity.current;
      const seconds = Math.floor(diff / 1000);

      // ⭐ If this line is not seen, it means setInterval has stopped
      // console.log(`⏱️ [检查中] 已经静止: ${seconds} 秒`);
      // console.log(`⏱️ [检查中] `, window.location.pathname);
      // console.log(`⏱️ [检查中] `, window.location.pathname.includes('/login'));
    
      if (diff > 180000) { // 3minute
        // console.log("🚨 [Timeout] Preparing to redirect...");
        clearInterval(timerInstance.current);
        // alert("Session Expired!");
        showExpiredMessage();
        dispatch(clearUserInfo());
        localStorage.clear();
        window.location.href = "/login";
      }
    }, 10000);

    // 4. Cleanup function
    return () => {
      // console.log("🧹 [Debug] IdleTimer Uninstalling...");
      window.removeEventListener("mousedown", update);
      window.removeEventListener("keydown", update);
      window.removeEventListener("scroll", update);
      window.removeEventListener("touchstart", update);
      if (timerInstance.current) clearInterval(timerInstance.current);
    };
  }, [dispatch]); // ⚠️ Note: The `location` option has been removed from the dependencies to prevent it from constantly restarting due to route changes.

  return null;
}

function showExpiredMessage() {
  const div = document.createElement("div");
  div.style.cssText = "position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:99999;background:rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;";
  div.innerHTML = `<div style="background:white;padding:20px;border-radius:8px;border-top:5px solid red;">Session Expired!</div>`;
  document.body.appendChild(div);
}